<template>
  <div class="h-100">
    <div class="content-page p-3 pb-5 h-100">
      <b-row class="h-5">
        <b-col cols="12">
          <S040000Menu
            :t="t"
            :dictEnum="dictEnum"
            :isLeaveRecordVisible="
              hasRight('AlwRead', Settings.MenuID.StaffLeaveRecord)
            "
            :isStaffAttendanceVisible="
              hasRight('AlwRead', Settings.MenuID.StaffAttendance)
            "
            :isMonthlyVisible="
              hasRight('AlwRead', Settings.MenuID.MonthlyLeaveBalance)
            "
            :isOutdoorVisible="
              hasRight('AlwRead', Settings.MenuID.OutdoorWorkAllowance)
            "
            :isTaxReturnVisible="hasRight('AlwRead', Settings.MenuID.TaxReturn)"
          />
        </b-col>
      </b-row>

      <b-row class="h-10" align-v="center">
        <b-col cols="12">
          <b-row align-v="center">
            <b-col cols="3">
              <date-picker
                id="dpMonth"
                :placeholder="this.t.t(dictEnum.LBL_Month)"
                v-model="month"
                :lang="lang"
                type="month"
                format="MM/YYYY"
                v-bind:editable="false"
                v-bind:clearable="false"
              ></date-picker>
            </b-col>

            <b-col cols="9" align-self="center" class="text-right">
              <button class="btn btn-info" @click="onSendEmail">
                {{ this.t.t(dictEnum.BTN_SendEmail) }}
              </button>
              <button class="btn btn-info" @click="search">
                {{ this.t.t(dictEnum.LBL_Filter) }}
              </button>
              <download-excel
                v-if="hasRight('AlwExp', Settings.MenuID.MonthlyLeaveBalance)"
                class="btn btn-primary"
                :fetch="ExportTableData"
                type="xls"
                name="MonthlyBalance.xls"
                :meta="[{ key: 'charset', value: 'utf-8' }]"
                >{{ this.t.t(dictEnum.BTN_Export) }}</download-excel
              >
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row class="h-80">
        <b-col cols="12" class="h-100">
          <div class="tab-content bg-white h-100">
            <div class="tab-pane active table-responsive color-table h-85">
              <b-table
                :items="tableData"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                thead-tr-class="headTr"
                tbody-tr-class="bodyTr"
              ></b-table>
            </div>
            <b-row
              no-gutters
              class="pt-3"
              style="position: absolute;bottom: 0;"
              v-if="tableData.length > 0"
            >
              <b-col cols="2">
                <b-pagination
                  first-number
                  last-number
                  limit="10"
                  v-model="currentPage"
                  :per-page="perPage"
                  :total-rows="tableData.length"
                ></b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import moment from "moment";
import MenuRightSerivce from "@/service/MenuRightService";
import ReportService from "@/service/ReportService";
import $t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import S040000Menu from "@/components/S040000-Report/S040000-Menu.vue";
import { datePickerLang } from "@/constants/globalConstants";
import Settings from "../../constants/Settings";

export default {
  components: {
    DatePicker,
    moment,
    S040000Menu
  },
  computed: {
    user() {
      return this.$store.getters[StoreGetter.user];
    },
    userName() {
      return this.$store.getters[StoreGetter.user].Lang == "EN"
        ? this.$store.getters[StoreGetter.user].EngName
        : this.$store.getters[StoreGetter.user].ChiName;
    }
  },
  data() {
    return {
      menuRights: { allRights: {}, rightsForThisMenu: {} },
      t: $t,
      Settings: Settings,
      menuId: Settings.MenuID.MonthlyLeaveBalance,
      dictEnum: dictEnum,

      columnsExport: {
        StaffName: "StaffName",
        LeaveTypeDesc: "LeaveTypeDesc",
        BF: "BF",
        Addition: "Addition",
        Claimed: "Claimed",
        Adjustment: "Adjustment",
        CF: "CF"
      },
      tableData: [],
      excelData: [],

      month: moment()
        .startOf("month")
        .format(Settings.DateTime.yyyymmdd),
      lang: datePickerLang,
      fields: [
        {
          key: "StaffName",
          label: $t.t(dictEnum.LBL_StaffName)
        },
        {
          key: "LeaveTypeDesc",
          label: $t.t(dictEnum.LBL_LeaveType)
        },
        {
          key: "BF",
          label: "BF"
        },
        {
          key: "Addition",
          label: $t.t(dictEnum.LBL_Addition)
        },
        {
          key: "Claimed",
          label: $t.t(dictEnum.LBL_Claimed)
        },
        {
          key: "Adjustment",
          label: $t.t(dictEnum.LBL_Adjustment)
        },
        {
          key: "CF",
          label: "CF"
        }
      ],
      currentPage: 1,
      perPage: 15
    };
  },
  methods: {
    hasRight(key) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.menuRights.allRights = this.$store.getters[
        StoreGetter.sysMenu
      ];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    async sendemail() {
      const obj = {
        date: moment(this.month).format(Settings.DateTime.yyyymmdd),
        lang: "EN"
      };
      const response = await ReportService.sendEmail(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async onSendEmail() {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: this.t.t(dictEnum.WARN_SendEmail),
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        await this.sendemail();
      }
    },

    async ExportTableData() {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: this.t.t(dictEnum.MSG_ExportFile),
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        const list = [];
        if (this.ExcelData.length > 0) {
          this.ExcelData.forEach(x => {
            const option = {
              StaffName: x.StaffName,
              LeaveTypeDesc: x.LeaveTypeDesc,
              BF: x.BF,
              Addition: x.Addition,
              Claimed: x.Claimed,
              Adjustment: x.Adjustment,
              CF: x.CF
            };
            list.push(option);
          });
        }
        return list;
      }
    },

    async search() {
      if (!this.month) {
        SweetAlertService.warning(
          "Warn",
          this.t.t(dictEnum.LBL_Month) + this.t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }

      if (this.month == "Invalid date") {
        SweetAlertService.warning(
          "Warn",
          this.t.t(dictEnum.LBL_Month) + this.t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }

      const date = moment(this.month).format(Settings.DateTime.yyyymmdd);
      const obj = {
        date: date,
        BalAsNumber: "false"
      };

      const response = await ReportService.getStaffMonthlyLeaveBalance(obj);
      obj.BalAsNumber = "true";
      const ExcelResponse = await ReportService.getStaffMonthlyLeaveBalance(
        obj
      );

      if (response.data.IsSuccess) {
        this.tableData = response.data.Data;
        this.ExcelData = ExcelResponse.data.Data;
        this.getPerPage();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getPerPage() {
      const tableEle = await document.getElementsByClassName("tab-pane");
      const headEle = await document.getElementsByClassName("headTr");
      const trEle = await document.getElementsByClassName("bodyTr");
      if (trEle.length > 0) {
        const tableHeight = tableEle[0].offsetHeight;
        const headHeight = headEle[0].offsetHeight;
        const trHeight = trEle[0].offsetHeight;
        let page = (tableHeight - headHeight * 2) / trHeight;
        page = Number(page.toFixed(0));
        this.perPage = page;
      }
    }
  },
  mounted() {
    this.assignRights();
    this.search();
  }
};
</script>
<style scoped lang="scss">
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  min-height: 158px !important;
}
.mx-calendar-icon {
  width: 100%;
  height: auto !important;
  color: #555;
  stroke-width: 8px;
  stroke: currentColor;
  fill: currentColor;
}
</style>



// WEBPACK FOOTER //
// src/components/S040000-Report/S040300-MonthlyLeaveBalance.vue